import {User as OidcUser} from 'oidc-client'

export enum AccessRole {
    NoAccess = 0,
    CemAdmin = 1,
    Client = 2,
    Guest = 3,
}

export interface IUser {
    id: string;
    email: string | undefined;
    avatar: string;
    username: string | undefined;
    givenName: string | undefined;
    familyName: string | undefined;
    accessRoleId: AccessRole;
    oidcUser: OidcUser;
}

export interface SigninRedirectCallbackReturn {
    user: IUser,
    returnUrl: string
}